/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Storage_Org_Quota_UsedInputs */



/**
* | output |
* | --- |
* | "Org Quota Used" |
*
* @param {Dashboard_Storage_Org_Quota_UsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_storage_org_quota_used = /** @type {((inputs?: Dashboard_Storage_Org_Quota_UsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Storage_Org_Quota_UsedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Genutzte Org-Quote")
	return /** @type {LocalizedString} */ ("Org Quota Used")
});